import { InputTypes } from 'constants/enums';
import { IFormField } from 'models/app';
import React from 'react';
import Modal from 'components/UI/DialogModal';
import Form from 'components/UI/Form';
import { CircularProgress, Grid, Stack } from '@mui/material';
import MuiButton from 'components/UI/MuiButton';
import { ICountry } from 'models/country';
import { useTranslation } from 'react-i18next';
import { IRole } from 'models/Roles';


interface Props {
  open: boolean;
  loading: boolean;
  role: IRole;
  onClose: () => void;
  onSubmit: () => void;
  onChanges: (name: string, value: any) => void;
}




const EditRole: React.FC<Props> = ({ open, loading, role, onClose, onSubmit, onChanges }) => {

  const {t} = useTranslation()
  
  let basicFields: IFormField[] = [

    {
      name: 'name',
      label: t('T_name'),
      type: InputTypes.TEXT,
      defaultValue: role.name,
      internalLabel: true,
      required: true
    },

  ];

  

  return (<>

    <Modal
      open={open}
      onClose={onClose}
      title={t('T_edit_role')}
      maxWidth="lg"
      children={<Stack spacing={2} p={2} >
        <Form fields={basicFields} onChange={onChanges} />
      </Stack>}
      actions={
        <Grid container alignItems={'center'} justifyContent={'space-between'} px={1} >
          <MuiButton variant="contained"
            sx={{ bgcolor: 'warning.main', color: 'white' }}
            size='large' onClick={onClose}>
            {t('T_cancel')}
          </MuiButton>
          <MuiButton variant="contained"
            sx={{ bgcolor: 'primary.main', color: 'white' }}
          
            size='large' onClick={onSubmit}>
             {t('T_save')}
           
          </MuiButton>

        </Grid>
      }
    />
  </>
  );
};

export default EditRole;
